var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 13.9993V4.66602H14.0003",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3333 13.9993V4.66602H42",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 42V51.3333H14.0003",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3333 42V51.3333H42",
    stroke: "#87ACFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 44.332L36.239 42.8924C35.2255 42.639 34.3264 42.053 33.6854 41.2281C33.0445 40.4031 32.6989 39.387 32.704 38.3424V35.946C34.7929 34.5579 36.5165 32.6866 37.7285 30.4908C38.9405 28.295 39.6054 25.8394 39.6667 23.332V20.9987C39.6667 17.9045 38.4375 14.937 36.2496 12.7491C34.0617 10.5612 31.0942 9.33203 28 9.33203C24.9058 9.33203 21.9383 10.5612 19.7504 12.7491C17.5625 14.937 16.3333 17.9045 16.3333 20.9987V23.332C16.3951 25.8398 17.0607 28.2957 18.2736 30.4915C19.4864 32.6874 21.2109 34.5584 23.3007 35.946V38.3424C23.3057 39.387 22.9601 40.4031 22.3192 41.2281C21.6783 42.053 20.7791 42.639 19.7657 42.8924L14 44.332",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d8082408.svg";
export { ForwardRef as ReactComponent };